import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBell, faBars } from '@fortawesome/free-solid-svg-icons';
import ConfirmDialog from './ConfirmDialog';

const Header = ({ user, onLogout, toggleSidebar, title }) => {
    const [isConfirmOpen, setConfirmOpen] = useState(false);

    const handleLogoutClick = () => {
        setConfirmOpen(true);
    };

    const handleConfirmLogout = () => {
        onLogout();
        setConfirmOpen(false);
    };

    const handleCloseConfirm = () => {
        setConfirmOpen(false);
    };

    return (
        <>
            <header id="header" className="bg-white shadow-sm border-b border-gray-200 px-4 sm:px-8 py-4">
                <div className="flex justify-between items-center">
                    <div className="flex items-center">
                        <button onClick={toggleSidebar} className="lg:hidden mr-4 text-gray-600 hover:text-gray-900">
                            <FontAwesomeIcon icon={faBars} className="text-xl" />
                        </button>
                        <div>
                            <h1 className="text-xl sm:text-2xl font-bold text-gray-900">{title}</h1>
                            {user && user.name && <p className="text-xs sm:text-sm text-gray-600">Selamat datang kembali, {user.name}!</p>}
                        </div>
                    </div>
                    <div className="flex items-center space-x-2 sm:space-x-4">
                        <button className="relative p-2 text-gray-400 hover:text-gray-600">
                            <FontAwesomeIcon icon={faBell} className="text-xl" />
                        </button>
                        <div className="hidden sm:flex items-center space-x-3">
                            <svg className="w-8 h-8 rounded-full bg-gray-300 text-gray-600 p-1" fill="currentColor" viewBox="0 0 24 24">
                                <path d="M24 20.993V24H0v-2.993A14.977 14.977 0 0112.004 15c4.904 0 9.26 2.354 11.996 5.993zM16.002 8.999a4 4 0 11-8 0 4 4 0 018 0z" />
                            </svg>
                            {user && user.phoneNumber && <p className="text-sm text-gray-600">{user.phoneNumber}</p>}
                        </div>
                        <button 
                            onClick={handleLogoutClick} 
                            className="px-3 sm:px-4 py-2 text-sm sm:text-base font-bold text-white bg-red-500 rounded-md hover:bg-red-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500"
                        >
                            Keluar
                        </button>
                    </div>
                </div>
            </header>
            <ConfirmDialog
                isOpen={isConfirmOpen}
                onClose={handleCloseConfirm}
                onConfirm={handleConfirmLogout}
                title="Konfirmasi Keluar"
                message="Apakah Anda yakin ingin keluar?"
            />
        </>
    );
};

export default Header;
